import { render, staticRenderFns } from "./ArticleFormField.vue?vue&type=template&id=d1f55646&scoped=true&"
import script from "./ArticleFormField.vue?vue&type=script&lang=js&"
export * from "./ArticleFormField.vue?vue&type=script&lang=js&"
import style0 from "./ArticleFormField.vue?vue&type=style&index=0&id=d1f55646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f55646",
  null
  
)

export default component.exports